export const createNotification = (type, title, message) => {
  return {
    type,
    title,
    message,
    label: title,
  };
};
